export var AnimationVariants;
(function (AnimationVariants) {
    AnimationVariants["Hidden"] = "hidden";
    AnimationVariants["Visible"] = "visible";
    AnimationVariants["Active"] = "active";
})(AnimationVariants || (AnimationVariants = {}));
